<template>
  <HModal
    :visible="visible"
    :show-close="false"
  >
    <div class="exchange-vip">
      <header>
        PDF-兑换会员
        <div
          class="close-btn"
          @click="close"
        />
      </header>
      <div class="exchange-wrapper">
        <p class="title">
          输入兑换码获取会员
        </p>
        <input
          v-model="redeemCode"
          type="text"
          placeholder="请输入兑换码"
          @focus="resetErrorMsg"
          @keyup.enter="clickRedeem"
        >
        <p class="msg">
          {{ errMsg }}
        </p>
        <button
          class="btn"
          @click="clickRedeem"
        >
          点击兑换
        </button>
        <p class="explain">
          兑换说明
        </p>
        <p class="text">
          1、一个兑换码只能绑定一个账号，兑换成功后立即失效
        </p>
        <p class="text">
          2、已经开通了相关会员服务员的用户，将会延长会员的时间
        </p>
      </div>
    </div>
  </HModal>
</template>

<script>
import { defineComponent, reactive, toRefs, computed } from '@vue/composition-api'
import { exchangeVip } from '@/api/act'
import { UserService } from '@/services/user.service'
import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'
import enterprise from '@/client/modules/enterprise.js'

export default defineComponent({
  name: 'ExchangeVipPop',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, context) {
    const injector = useReflectiveInjector()
    const user = injector.get(UserService)

    const viewsModel = reactive({
      redeemCode: '',
      errMsg: '',
    })

    const visible = computed({
      get () {
        return props.value
      },
      set (val) {
        viewsModel.redeemCode = ''
        resetErrorMsg()
        context.emit('input', val)
      },
    })

    /** 兑换 */
    function clickRedeem () {
      const code = viewsModel.redeemCode.trim()
      enterprise.REPORT.reportRedeemCodeKfmt({ step: 3 })

      if (!code) {
        viewsModel.errMsg = '请输入兑换码'
        enterprise.REPORT.reportRedeemCodeKfmt({ result: 2 })
        return
      }

      exchangeVip({ type: 'code', code, frm: 'pdf' })
        .then(exchangeVipResult)
        .catch(() => {
          resetErrorMsg()
        })
    }

    /** 兑换结果处理 */
    function exchangeVipResult (res) {
      const code = res.resp_common?.ret

      const codeMap = {
        0: { result: 1, msg: '兑换成功' },
        4912001: { result: 2, msg: '兑换码不存在' },
        4912003: { result: 3, msg: '兑换码已被使用' },
        4912004: { result: 4, msg: '兑换码已过期' },
      }

      if (codeMap[String(code)]) {
        const result = codeMap[String(code)].result
        const msg = codeMap[String(code)].msg
        enterprise.REPORT.reportRedeemCodeKfmt({ result })
        context.root.$toast(msg)

        if (code === 0) {
          user.refresh()
        }
        return
      }

      context.root.$toast('兑换失败')
    }

    function close () {
      visible.value = false
      enterprise.REPORT.reportRedeemCodeKfmt({ step: 4 })
    }

    function resetErrorMsg () {
      viewsModel.errMsg = ''
    }

    return {
      ...toRefs(viewsModel),
      visible,
      clickRedeem,
      close,
      resetErrorMsg,
    }
  },
})
</script>

<style scoped lang="scss">
.exchange-vip {
  width: 350px;
  height: 350px;
  background: #fff;
  header {
    box-sizing: border-box;
    padding-left: 16px;
    width: 350px;
    height: 28px;
    line-height: 28px;
    background: #f7d75c;
    border-radius: 1px;
    position: relative;
    font-size: 12px;
    font-weight: 400;
    color: #a77727;
    .close-btn {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 2px;
      right: 2px;
      background-image: url(~@/assets/images/not-close.png);
      cursor: pointer;
      &:hover {
        background-position-x: center;
      }
      &:active {
        background-position-x: right;
      }
    }
  }

  .exchange-wrapper {
    width: 310px;
    box-sizing: border-box;
    margin: 0 auto;
    .title {
      font-size: 14px;
      font-weight: 400;
      color: #444444;
      margin-top: 27px;
      margin-bottom: 10px;
    }
    input[type="text"] {
      width: 310px;
      height: 33px;
      line-height: 33px;
      border: 1px solid #bbbbbb;
      border-radius: 4px;
      display: block;
      box-sizing: border-box;
      padding-left: 10px;
    }
    .msg {
      height: 16px;
      font-size: 12px;
      color: #ff0000;
      text-align: center;
    }
    .btn {
      width: 90px;
      height: 30px;
      background: #76bd44;
      border-radius: 1px;
      border: none;
      display: block;
      cursor: pointer;
      margin: 4px auto 29px auto;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      &:hover {
        background: rgba(118, 189, 68, 0.9);
      }
    }
    .explain {
      font-size: 14px;
      color: #666666;
      padding-bottom: 6px;
    }
    .text {
      width: 300px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
    }
  }
}
</style>
